import React, { useEffect, useRef, useState } from 'react';
import './Gallery.css';

import { GalleryItem, GalleryTabs, Heading } from '../../../components';
import { galleryContent } from '../../../constants';

import Isotope from 'isotope-layout';

// Import react-photo-view components and styles
import { PhotoProvider } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';



const Gallery = () => {

  // State
  const [category, setCategory] = useState('all');
  const iso = useRef(null);
  const gridRef = useRef(null);

  // Function to format category names as Isotope classes
  const formatCategory = (name) => name.toLowerCase().replace(/\s+/g, '-');

  // Get unique categories from gallery
  const categories = ['all', ...new Set(galleryContent.map(item => formatCategory(item.category)))];

  // Initialize Isotope
  useEffect(() => {
    iso.current = new Isotope(gridRef.current, {
      itemSelector: '.gallery-item',
      layoutMode: 'fitRows',
    });

    return () => {
      iso.current.destroy();
    };
  }, []);

  // Apply filter when category changes
  useEffect(() => {
    if (iso.current) {
      iso.current.arrange({
        filter: category === 'all' ? '*' : `.${category}`, // Filters by class name
      });
    }
  }, [category]);

  return (
    <>
      <section className='gallery'>

        <Heading title={'our Gallery'} />

        {/* Gallery Tabs */}
        <ul className="tab-buttons">
          {categories.map((item) => (
            <GalleryTabs
              key={item}
              id={item}
              title={item.replace(/-/g, ' ')} // Show original category name
              setSelected={() => setCategory(item)}
              active={category === item}
            />
          ))}
        </ul>

        {/* Gallery */}
        <PhotoProvider>
          <div className="box-container" ref={gridRef}>
            {galleryContent.map((item, index) => {
              const className = formatCategory(item.category);
              return (
                <GalleryItem
                  key={index}
                  id={index}
                  image={item.image}
                  title={item.title}
                  category={item.category}
                  className={className} // Add class for Isotope filtering
                />
              );
            })}
          </div>
        </PhotoProvider>
      </section>

    </>
  );
};

export default Gallery;